<div class="row ch-ggs-web-suite-card-group">
  <div class="col-sm-6 col-lg-3" *ngFor="let card of cards">
    <a
      href="javascript:;"
      (click)="selected.emit(card.transportMode)"
      class="ch-ggs-web-suite-card clickable"
    >
      <div
        class="ch-ggs-web-suite-card-img-fake"
        [ngSwitch]="card.transportMode"
      >
        <span *ngSwitchCase="transportModes.Road" class="ifc-custom ifc-road"
          ><span class="path1"></span><span class="path2"></span
        ></span>
        <span class="ifc-custom ifc-rail" *ngSwitchCase="transportModes.Rail"
          ><span class="path1"></span><span class="path2"></span
        ></span>
        <span class="ifc-custom ifc-sea" *ngSwitchCase="transportModes.Sea"
          ><span class="path1"></span><span class="path2"></span
          ><span class="path3"></span><span class="path4"></span
          ><span class="path5"></span
        ></span>
        <div class="ifc-custom" *ngSwitchCase="transportModes.Air">
          <span class="ifc-custom ifc-air"></span>
        </div>
      </div>
      <div class="ch-ggs-web-suite-card-main">
        <h2 class="ch-ggs-web-suite-card-title" *ngIf="card.title">
          {{ card.title }}
        </h2>
        <p class="ch-ggs-web-suite-card-text" *ngIf="card.text">
          {{ card.text }}
        </p>
        <div
          class="btn btn-block btn-iconed btn-iconed-simple mt-auto"
          *ngIf="card.buttonText"
        >
          {{ card.buttonText }}
          <i aria-hidden="true" class="btn-icon ifc-custom ifc-arrow-right"></i>
        </div>
      </div>
    </a>
  </div>
</div>
<ng-content></ng-content>
